import { render, staticRenderFns } from "./editable-table.vue?vue&type=template&id=646da60f"
import script from "./editable-table.vue?vue&type=script&lang=js"
export * from "./editable-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports